import { Component, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-mdi-eye',
  templateUrl: './mdi-eye.component.html',
  styleUrls: ['./mdi-eye.component.css'],
})
export class MdiEyeComponent implements OnInit {
  @Input()
  show = false;

  constructor() {}

  ngOnInit(): void {}
}
